import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class StrechLine {
  _firstDot: marietta.core.Point;

  get firstDot() {
    return this._firstDot;
  }

  set firstDot(_dot) {
    this._firstDot = _dot;
    this.updateTransforms();
  }

  _secondDot: marietta.core.Point;

  get secondDot() {
    return this._secondDot;
  }

  set secondDot(_dot) {
    this._secondDot = _dot;
    this.updateTransforms();
  }

  public spt: SVGSprite;

  /**
   * コンストラクタ
   * */
  constructor(targetSprite: SVGSprite, id: number) {
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    const sc: number = 1 / root.scaleX;

    // ラインの作成
    const viewObj: any = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    viewObj.setAttribute('stroke', '#3598DC');
    viewObj.setAttribute('stroke-width', String(sc));
    viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(10, 10)));
    viewObj.setAttribute('id', `line_${id}`);
    this.spt = new SVGSprite(viewObj);

    targetSprite.addChild(this.spt);
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    if (this.firstDot === undefined || this.secondDot === undefined) return;
    this.viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(this.firstDot.x, this.firstDot.y), new marietta.core.Point(this.secondDot.x, this.secondDot.y)));
  }

  /**
   * HTMLElementの取得
   */
  public get viewObj(): HTMLElement {
    return this.spt.element;
  }

  /**
   * 線の色の変更
   */
  public set lineColor(color: string) {
    this.spt.element.style.stroke = color;
  }
}
